<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Report Service Calls</h1>
            <hr>
            <mdb-row>
                <mdb-col md="3">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true" v-model="from" label="Date From" />
                    </div>
                </mdb-col>
                <mdb-col md="3">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true"  v-model="to" label="Date To" />
                    </div>
                </mdb-col>
                <mdb-col md="6">
                    <mdb-btn @click="getData()" v-if="!loading" outline="primary"><mdb-icon icon="search" /> Search</mdb-btn>
                    <mdb-spinner small v-if="loading" />
                </mdb-col>
            </mdb-row>
            <div v-if="loading">Wait.. Processing dont panic...</div>
            <mdb-row>
                <mdb-col col="12">Total Calls: <span class="font-weight-bold">{{total_calls}}</span></mdb-col>
                <mdb-col col="3" v-for="(merchant, index) in total_merchant_count" v-bind:key="index">{{merchant.key}}: <span class="font-weight-bold">{{merchant.value}}</span></mdb-col>
            </mdb-row>
            <mdb-tbl responsive striped v-if="!loading">
                <mdb-tbl-head>
                <tr>
                    <th width="5%">#</th>
                    <th>Merchant Name</th>
                    <th>Order Number</th>
                    <th>Phone Number</th>
                    <th>Date Time</th>
                    <th>Action</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                <tr style="cursor: pointer" v-for="(record, index) in records" :key="record.id">
                    <td>{{index+1}}</td>
                    <td>{{record.merchant.name}}</td>
                    <td>{{record.order_number}}</td>
                    <td>{{record.phone_number}}</td>
                    <td>{{momentFormatDate16(record.created_at)}}</td>
                    <td>
                        <mdb-btn @click="showOrderDetail(record)" color="primary" size="sm"><mdb-icon far icon="eye" /></mdb-btn>
                    </td>
                </tr>
                </mdb-tbl-body>
            </mdb-tbl>
        </mdb-container>
        <OrderDetailComponent :id="focus_order_id" :visible="order_detail_component" :close="closeOrderDetailComponent" :callback="callback" />
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbRow, mdbCol, mdbDatePicker, mdbBtn, mdbSpinner ,mdbTbl, mdbTblHead, mdbTblBody, mdbIcon } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {momentFormatDate16} from '../js/helper';
// import {APP_FILE_URL} from '../js/config';
import OrderDetailComponent from '../components/OrderDetailComponent';

export default {
  name: 'report_service_calls',
  components: {
    mdbContainer,mdbRow, mdbCol, mdbDatePicker, mdbBtn, mdbSpinner,
    AppNavigation, mdbTbl, mdbTblHead, mdbTblBody, mdbIcon, OrderDetailComponent
  },
  data: ()=>({
      loading:false,
      from: "",
      to: "",
      records: [],
      total_calls: 0,
      total_merchant_count: [],
      focus_order_id: 0,
      order_detail_component: false,
  }),
  methods: {
      getData(){
        if(this.loading){
            return false;
        }
        this.loading=true;
        ajax({
            url: "admin/get_report_service_calls",
            data: {
                from: this.from,
                to: this.to
            },
            complete: ()=>this.loading=false,
            success: result=>{
                let temp={};
                let final_temp=[];
                result.data.forEach(element => {
                    if(temp[element.merchant.name]){
                        temp[element.merchant.name]=temp[element.merchant.name]+1;
                    }else{
                        temp[element.merchant.name]=1;
                    }
                });
                let keys=Object.keys(temp);
                keys.forEach(element => {
                    let obj={key: element, value: temp[element]};
                    final_temp.push(obj);
                });
                this.total_merchant_count=final_temp;
                this.records=result.data;
                this.total_calls=this.records.length;
            },
        }, this)
      },
      momentFormatDate16(date){
          return momentFormatDate16(date);
      },
      closeOrderDetailComponent(){
          this.order_detail_component=false;
      },
      callback(){
          this.getData();
      },
      showOrderDetail(record){
          this.focus_order_id=record.service_order.id;
          this.order_detail_component=true;
      }
  },
  mounted: function(){
    let date = new Date();
    let month = date.getMonth()+1;
    this.from=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
    this.to=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
    this.getData();
  }
}
</script>
